import React from "react";
import SelectArrowDate from "components/atoms/SelectArrowDate";
import { useEventsContext } from "hooks/useContexts";
import { useTranslation } from "react-i18next";
import { getNewDate } from "shared/utils";

import styles from "./style.module.scss";

export default function Toolbar({
  setView,
  view,
  selectedTab,
  setSelectedTab,
  customStyles = {},
  seeYearly = false,
  currentDate,
  setCurrentDate,
  setRangeDate,
}) {
  const { t } = useTranslation();
  const { usersTimezoneLocation } = useEventsContext();

  return (
    <div className="w-full h-auto lg-[36px] flex flex-col justify-center items-center gap-4 lg:flex-row lg:justify-between mb-8">
      <SelectArrowDate
        currentDate={getNewDate({
          date: !currentDate ? new Date() : currentDate,
          usersTimezoneLocation,
          getDateObjectFromUsersTimezone: true,
        })}
        customStyle={customStyles}
        setCurrentDate={setCurrentDate}
        setRangeDate={setRangeDate}
        view={view}
      />
      <div className={`${styles.btnDiv}`}>
        <div
          className={
            selectedTab === 0 ? `${styles.btnCalActive}` : `${styles.btnCal}`
          }
          onClick={() => {
            setSelectedTab(0);
            setView("day");
          }}
        >
          <span>{t("daily")}</span>
        </div>
        <div
          className={
            selectedTab === 1 ? `${styles.btnCalActive}` : `${styles.btnCal}`
          }
          onClick={() => {
            setSelectedTab(1);
            setView("week");
          }}
        >
          <span>{t("weekly")}</span>
        </div>
        <div
          className={
            selectedTab === 2 ? `${styles.btnCalActive}` : `${styles.btnCal}`
          }
          onClick={() => {
            setSelectedTab(2);
            setView("month");
          }}
        >
          <span>{t("monthly")}</span>
        </div>
        {seeYearly ? (
          <div
            className={
              selectedTab === 3 ? `${styles.btnCalActive}` : `${styles.btnCal}`
            }
            onClick={() => {
              setSelectedTab(3);
              setView("yearly");
            }}
          >
            <span>{t("yearly")}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
